import { buildElementObject } from "../shared/buildElementObject";
import { buildNavigationType } from "../shared/buildNavigationType";
import { buildPageObject } from "../shared/buildPageObject";
import { EventAction, EventName } from "../types";

import type { ElementClickEvent, ElementClickInput } from "./types";

type EventBuilder = (input: ElementClickInput) => ElementClickEvent;

const elementClickEventBuilder: EventBuilder = (input) => {
  const { elementName, customProperties } = input;

  const timestamp = new Date().toISOString();

  const elementObject = buildElementObject(elementName);
  const pageObject = buildPageObject();
  const navigationType = buildNavigationType();

  return {
    name: EventName.ElementClick,
    action: EventAction.Click,
    target: elementObject,
    origin: pageObject,
    navigationType,
    timestamp,
    customProperties,
  };
};

export { elementClickEventBuilder };
